function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1,0,0,1,1,0.5)"
}, React.createElement("path", {
  d: "M20,23C21.104,23 22,23.896 22,25C22,26.104 21.104,27 20,27C18.896,27 18,26.104 18,25C18,23.896 18.896,23 20,23ZM10,23C11.104,23 12,23.896 12,25C12,26.104 11.104,27 10,27C8.896,27 8,26.104 8,25C8,23.896 8.896,23 10,23ZM20,13.5C21.104,13.5 22,14.396 22,15.5C22,16.604 21.104,17.5 20,17.5C18.896,17.5 18,16.604 18,15.5C18,14.396 18.896,13.5 20,13.5ZM10,13.5C11.104,13.5 12,14.396 12,15.5C12,16.604 11.104,17.5 10,17.5C8.896,17.5 8,16.604 8,15.5C8,14.396 8.896,13.5 10,13.5ZM20,4C21.104,4 22,4.896 22,6C22,7.104 21.104,8 20,8C18.896,8 18,7.104 18,6C18,4.896 18.896,4 20,4ZM10,4C11.104,4 12,4.896 12,6C12,7.104 11.104,8 10,8C8.896,8 8,7.104 8,6C8,4.896 8.896,4 10,4Z"
}));
var SvgDraggable = function SvgDraggable(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgDraggable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/draggable.9af842a8.svg";
export { ForwardRef as ReactComponent };